import { render, staticRenderFns } from "./templateOrder.vue?vue&type=template&id=2e430ad2&scoped=true"
import script from "./templateOrder.vue?vue&type=script&lang=js"
export * from "./templateOrder.vue?vue&type=script&lang=js"
import style0 from "./templateOrder.vue?vue&type=style&index=0&id=2e430ad2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e430ad2",
  null
  
)

export default component.exports